import styled from "@emotion/styled";

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0;
  list-style: none;
  padding: 1rem 0;
`;
